import logo from '../../img/logo.png';
import './Loading.css';

const Loading = () => {
  return (
    <main className='Loading'>
      <img src={logo} alt='' className='LoadingImg' />
    </main>
  );
};

export default Loading;
